import PropTypes from 'prop-types';
import { forwardRef, useState, useEffect } from 'react';

// material-ui
import {
    Button,
    Dialog,
    Grid,
    IconButton,
    Zoom,
    DialogContent
} from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

// assets
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';

// third party
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Transition = forwardRef((props, ref) => <Zoom ref={ref} {...props} />);

const VenueContent = ({ open, handleClose, selectedContent, rows, setReload, venueUuid }) => {

    const [text, setText] = useState(null);

    const handleChange = (value) => {
        setText(value);
    };

    const closeDialog = () => {
        setText(null);
        handleClose();
    };

    const updateContent = () => {
        let findContent = rows.find(x => x.mkey === selectedContent);
        const payload = {
            mkey: selectedContent,
            uuid_venue: venueUuid,
            mvalue: text
        }
        if (findContent) {
            updateSettingsApi.execute(payload, findContent.uuid);
        } else {
            createSettingsApi.execute(payload);
        }
    };

    const successHandler = () => {
        setReload(r => !r);
        closeDialog();
    };

    const updateSettingsApi = useApi(VenueService.updateVenueSettings, successHandler, true);
    const createSettingsApi = useApi(VenueService.createVenueSettings, successHandler, true);

    useEffect(() => {
        let findContent = rows.find(x => x.mkey === selectedContent);
        if (findContent) {
            setText(findContent.mvalue);
        } else {
            setText(null);
        }
    }, [selectedContent])

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={closeDialog}
            fullWidth
            maxWidth="lg"
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent sx={{ p: 0 }}>
                <MainCard
                    title={selectedContent === 'venue_content' ? 'Update Venue Content' : selectedContent === 'venue_terms' ? 'Update Venue Terms' : 'Update Venue Terms & Conditions'}
                    secondary={
                        <IconButton onClick={closeDialog} size="large" aria-label="Close">
                            <HighlightOffTwoToneIcon fontSize="small" />
                        </IconButton>
                    }
                    sx={{ border: 0 }}
                >
                    <ReactQuill value={text} onChange={handleChange} />
                    <Grid container justifyContent="flex-end" mt={2}>
                        <Grid item>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={updateContent}
                            >
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </MainCard>
            </DialogContent>
        </Dialog>
    );
};

VenueContent.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func
};

export default VenueContent;
